import { API_SHIPPING } from "../../config";
import axios from "axios";

export const getCouriers = async () => {
  const res = await axios.get(`${API_SHIPPING}/v1/public/couriers`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
  const couriers = await res.data.couriers.reduce((r, i) => {
    r.push({
      courierName: i.courier_name,
      courierCode: i.courier_code,
      courierServiceName: i.courier_service_name,
      courierServiceCode: i.courier_service_code,
      tier: i.tier,
      description: i.description,
      serviceType: i.service_type,
      shippingType: i.shipping_type,
      shipmentDurationRange: i.shipment_duration_range,
      shipmentDurationUnit: i.shipment_duration_unit,
    });
    return r;
  }, []);
  return {
    success: true,
    couriers,
  };
};
